import React from 'react';
import { TableRow, TableCell, Checkbox, IconButton, Typography, Switch, Chip } from '@mui/material';
import { MoreVert as MoreIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

const formatRate = (item) => {
    if (item?.formatted_rate) return item.formatted_rate;
    const num = parseFloat(item?.rate_percent);
    if (Number.isNaN(num)) return '-';
    return `${num.toFixed(3)}%`;
};

const TaxRatesTableRow = ({
    item,
    index = 0,
    isSelected,
    onRowCheckboxClick,
    onMenuOpen,
    onToggleActive,
}) => {
    const { i18n } = useTranslation();
    const lng = i18n.language || 'en';

    const name = item.name?.[lng] || item.name?.en || item.name?.ar || item.name || '-';
    const zoneName =
        item.zone?.name?.[lng] ||
        item.zone?.name?.en ||
        item.zone?.name?.ar ||
        item.zone?.name ||
        '-';

    return (
        <TableRow hover selected={isSelected}>
            <TableCell padding="checkbox">
                <Checkbox checked={isSelected} onClick={(e) => onRowCheckboxClick(e, item.id)} />
            </TableCell>

            <TableCell align="start">{index + 1}</TableCell>

            <TableCell>
                <Typography variant="body2" fontWeight="medium">{name}</Typography>
            </TableCell>

            <TableCell align="center">
                <Chip
                    size="small"
                    label={formatRate(item)}
                    color="primary"
                    variant="tonal"
                    sx={{ fontWeight: 'bold', borderRadius: '6px', minWidth: '70px' }}
                />
            </TableCell>

            <TableCell align="center">
                <Typography variant="body2">{zoneName}</Typography>
            </TableCell>

            <TableCell align="center">
                <Switch
                    checked={!!item.is_active}
                    onChange={() => onToggleActive?.(item)}
                    color="primary"
                    size="small"
                />
            </TableCell>

            <TableCell align="center">
                <IconButton size="small" onClick={(e) => onMenuOpen(e, item)}>
                    <MoreIcon />
                </IconButton>
            </TableCell>
        </TableRow>
    );
};

export default TaxRatesTableRow;
